<template>
    <div>


        <ul id="nav_list" class="nav flex-column nav-pills">
            <li class="nav-item">
                <router-link :to="{name: 'my-orders'}" class="nav-link">
                    My Orders
                </router-link>
            </li>
            <!-- User Companies -->
            <li class="nav-item" v-for="(userRole, i) in customerRolesWithEdit">
                <router-link :to="{name: 'customerEdit', params: {customerId: userRole.customer_id}}" class="nav-link">
                    {{ customers[userRole.customer_id].name }}
                </router-link>
            </li>

            <!-- Admin Only Pages -->
            <template v-if="isCustomerAdminOnly">
                <b-dropdown-item :to="{name: 'customerAdmin'}" >Customers</b-dropdown-item>
            </template>
            <template v-else-if="$auth.check('admin')">
                <li class="nav-item">
                    <router-link :to="{name: 'page-list'}" class="nav-link">
                        Pages Editor
                    </router-link>
                </li>

                <b-nav-item-dropdown text="Order Admin">
<!--                    <b-dropdown-item :to="{name: 'all-orders'}">All Orders</b-dropdown-item>-->
                    <b-dropdown-item :to="{name: 'idle-carts'}">Idle Carts</b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown text="Customers">
                    <b-dropdown-item :to="{name: 'adoptions'}" >Adoptions</b-dropdown-item>
                    <b-dropdown-item :to="{name: 'customerAdmin'}" >Customers</b-dropdown-item>
                    <b-dropdown-item :to="{name: 'user-admin'}">Users</b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item-dropdown text="Store Config">
                    <b-dropdown-item :to="{name: 'schoolYear'}" >State-Year Mapping</b-dropdown-item>
                    <b-dropdown-item :to="{name: 'ship-rates'}" >Shipping Rates</b-dropdown-item>
                    <b-dropdown-item :to="{name: 'charter-schools'}">Charter Schools</b-dropdown-item>
                    <b-dropdown-item :to="{name: 'markets'}">Markets</b-dropdown-item>
                    <b-dropdown-item :to="{name: 'images'}">Images</b-dropdown-item>
                    <b-dropdown-item :to="{name: 'store-config'}">Config</b-dropdown-item>
                </b-nav-item-dropdown>


                <!--                <li class="nav-item">-->
<!--                    <router-link :to="{name: 'south-dakota'}" class="nav-link">-->
<!--                        South Dakota-->
<!--                    </router-link>-->
<!--                </li>-->
            </template>
        </ul>
    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";
</style>

<script>
import { mapState } from 'vuex'

export default {
    data () {
        return {

        }
    },

    computed: mapState({
        affiliate_posts: state => state.affiliate.affiliate_posts,
        customers: state => state.dashboard.customers,
        customerRoles() {
            return this.$auth.user().customer_roles
        },
        customerRolesWithEdit() {
            return this.customerRoles.filter(role => role.permission == 'edit' || role.permission == 'admin')
        },

        // Temporary work-around for admins who only get access to the customer tool.
        isCustomerAdminOnly() {
            return this.$auth.user().id == 16564741;
        }

    }),
    mounted () {
    }
}
</script>
